import { universalAddressItem } from "./../../layout-items/index.js";
import { registerPayloadTypes } from "./../../vaa/index.js";
import { transferLayout, transferWithPayloadLayout } from "../tokenBridge/tokenBridgeLayout.js";
export const tbtcPayloadLayout = [
    { name: "recipient", ...universalAddressItem },
];
const namedPayloads = [
    // Payload when transferring to a chain with a TBTC L2WormholeGateway contract
    ["GatewayTransfer", transferWithPayloadLayout(tbtcPayloadLayout)],
    // Payload when transferring to a chain without a TBTC L2WormholeGateway contract
    // Just a normal token bridge transfer
    ["Transfer", transferLayout],
];
// factory registration:
import "../../registry.js";
registerPayloadTypes("TBTCBridge", namedPayloads);
//# sourceMappingURL=tbtcLayout.js.map